/*

  p a g e
  Page

  :description:
  An HTML component to provide a JS parallel to a standard "web page".
  
*/

//
//  :react & redux:
import React from 'react';

//
//  :code:
import './Page.css';
import Content from '../content/Content';
import Container from '../container/Container';

//
//  :packages:

//
//  :component:
const Page = (props) => {
  if (!props) {
    props = {}
  }
  return (
    <div id="eky-page" className='eky-page min-h-screen'>
      <Container>
        <Content>
          {props.children}
        </Content>
      </Container>
    </div>
  );
}

export default Page;
